import { render, staticRenderFns } from "./Addtrader.vue?vue&type=template&id=576b6c22"
import script from "./Addtrader.vue?vue&type=script&lang=js"
export * from "./Addtrader.vue?vue&type=script&lang=js"
import style0 from "./Addtrader.vue?vue&type=style&index=0&id=576b6c22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports